import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { RecoverPasswordActions } from './recover-password.actions';
import * as RecoverPasswordSelector from './recover-password.selector';

export enum StemRecover {
    FormEmail = 1,
    SendEmail = 2
}

@Injectable()
export class RecoverPasswordFacade {
    step$: Observable<number> = this.store.select(RecoverPasswordSelector.getStep);
    loading$: Observable<boolean> = this.store.select(RecoverPasswordSelector.getLoading);
    error$: Observable<boolean> = this.store.select(RecoverPasswordSelector.getError);
    done$: Observable<boolean> = this.store.select(RecoverPasswordSelector.getDone);
    authAccessToken$: Observable<string> = this.store.select(RecoverPasswordSelector.getAuthAccessToken);

    constructor(
        private store: NgRedux<any>,
        private actions: RecoverPasswordActions
    ) {}

    /**
     * reset the recover password state to the initial state
     */
    resetStep() {
        this.store.dispatch(this.actions.recoverPasswordResetStep());
    }

    /**
     * dispatch action to submit email address for password recovery
     * @param {string} email
     * @param {string} locale
     */
    submitEmail(email: string, locale: string, callback: string) {
        this.store.dispatch(this.actions.recoverPasswordRequest({ email, locale, callback }));
    }

    /**
     * set step state
     * @param {number} step
     */
    setRecoveryStep(step: number) {
        this.store.dispatch(this.actions.recoverPasswordSetStep(step));
    }

    /**
     * dispatches an action to set a new password
     * @param {string} password
     * @param {string} token
     * @param {string} locale
     * @param {boolean} ondemandRequest
     */
    setNewPassword(password: string, token: string, locale: string, ondemandRequest: boolean) {
        this.store.dispatch(this.actions.setNewPassword({ password, token, locale, ondemandRequest }));
    }
}
